import { render, staticRenderFns } from "./over.vue?vue&type=template&id=56975e32&scoped=true"
import script from "./over.vue?vue&type=script&lang=js"
export * from "./over.vue?vue&type=script&lang=js"
import style0 from "./over.vue?vue&type=style&index=0&id=56975e32&prod&lang=less&scoped=true"
import style1 from "./over.vue?vue&type=style&index=1&id=56975e32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56975e32",
  null
  
)

export default component.exports